export default {
  project: {
    category: {},
    country: {},
    user: {
      photo: {
        thumb: {},
        url: '',
      },
      profession: {},
    },
    photo: {
      thumb: {},
      url: '',
    },
    translation: {},
    translations: [],
    locale: '',
    currency: '',
    percent_funded: 0,
    submitted: false,
    published: false,
    owner: false,
  },
};



// WEBPACK FOOTER //
// ./src/models/project.js